<header>
  <div class="wrap">
    <div class="text" *ngIf="handledBom.unavailablePrice">
      <h3 class="title">{{ 'popins.noprice.title' | translate }}</h3>
    </div>
    <div class="text" *ngIf="!handledBom.unavailablePrice">
      <h3 class="title">{{ 'popins.price_info.title' | translate }}</h3>
      <b class="info">{{
        modalService.currentDatas.projectName
          ? modalService.currentDatas.projectName
          : ('popins.price_info.placeholder_project_' + customer.context | translate)
      }}</b>
    </div>
    <div class="header-actions">
      <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main">
  <div class="inner-content" *ngIf="!handledBom.unavailablePrice">
    <div class="text">
      <p class="no-furniture" *ngIf="handledBom.empty">{{ 'popins.price_info.empty' | translate }}</p>
      <table class="price-table" *ngIf="!handledBom.empty">
        <tbody>
          <tr *ngFor="let productCategory of handledBom.totalByCategories">
            <th>{{ 'popins.price_info.' + productCategory.key | translate }}</th>
            <td>{{ productCategory.price | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>{{ 'popins.price_info.total' | translate }}</th>
            <td>{{ handledBom.totalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <div class="inner-content unavailablePrice" *ngIf="handledBom.unavailablePrice">
    <div class="text">
      <p>{{ 'popins.noprice.p1' | translate }}</p>
      <p class="my-2">
        <b>{{ 'popins.noprice.p2' | translate }}</b>
      </p>
    </div>
    <div class="img-container">
      <img
        src="assets/img/zoomHelpCenter.png"
        srcset="assets/img/zoomHelpCenter@2x.png 236w"
        [alt]="'popins.noprice.alt' | translate" />
    </div>
  </div>
</div>
